// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__379Cf","title":"Header_title__1VEjh","side":"Header_side__1uDOx"};